import React from 'react';
import type { ConditionStatus } from '../../types/conditions';

/**
 * Status palette built from the Mortgage Depot brand: blues step from light → navy
 * as a condition progresses, charcoal grays for neutral states, and steel blue for cleared.
 */
export const statusStyles: Record<ConditionStatus, {
  label: string;
  badge: string;
  dot: string;
  bar: string;
}> = {
  none: {
    label: 'None',
    badge: 'bg-slate-100 text-slate-600 ring-slate-200',
    dot: 'bg-[#9AA0A7]',
    bar: 'bg-[#9AA0A7]'
  },
  new: {
    label: 'New',
    badge: 'bg-[#EAF2FB] text-[#2A6AB0] ring-[#C9DDF2]',
    dot: 'bg-[#4F8FD0]',
    bar: 'bg-[#4F8FD0]'
  },
  requested: {
    label: 'Requested',
    badge: 'bg-brand/10 text-brand-dark ring-brand/30',
    dot: 'bg-brand',
    bar: 'bg-brand'
  },
  submitted: {
    label: 'Submitted',
    badge: 'bg-[#E3EAF3] text-brand-dark ring-[#B9CBE0]',
    dot: 'bg-brand-dark',
    bar: 'bg-brand-dark'
  },
  review: {
    label: 'Review',
    badge: 'bg-[#EEEFF1] text-charcoal ring-[#D3D5D9]',
    dot: 'bg-[#5F6670]',
    bar: 'bg-[#5F6670]'
  },
  approved: {
    label: 'Approved',
    badge: 'bg-[#E1E8F0] text-[#0F3A66] ring-[#B4C3D4]',
    dot: 'bg-[#0F3A66]',
    bar: 'bg-[#0F3A66]'
  },
  cleared: {
    label: 'Cleared',
    badge: 'bg-steel-light text-steel-dark ring-steel/30',
    dot: 'bg-steel',
    bar: 'bg-steel'
  },
  waived: {
    label: 'Waived',
    badge: 'bg-[#E6E7E9] text-charcoal ring-[#C7C9CD]',
    dot: 'bg-charcoal',
    bar: 'bg-charcoal'
  }
};
interface StatusBadgeProps {
  status: ConditionStatus;
}
export function StatusBadge({
  status
}: StatusBadgeProps) {
  const s = statusStyles[status];
  return <span className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-semibold ring-1 ring-inset ${s.badge}`} data-id="element-295" data-mp="3nkvlfrvgwy1">
      <span className={`h-1.5 w-1.5 rounded-full ${s.dot}`} aria-hidden="true" data-id="element-296" data-mp="1u0s4z2ubzx34" />
      {s.label}
    </span>;
}